import ClientSDK from '../App/ClientSDK'

import { IAPIHealthInsurance, IAPIInvoiceCustomer } from './interfaces/IHealthInsurance'


type VatRate = {
  id: string;
  name: string;
  full_name: string;
  vat_percentage: number;
  default: boolean;
  ledger_account: null;
}

type Person = {
  uuid: string;
  name: string;
  firstName: string;
  AGBCode: null | string;
};

type ReceiptLine = {
  id: string;
  name: string;
  amount: number;
  price: number;
  discountPercentage: null;
  discount: null;
  discountTotal: number;
  vatPercentage: number;
  vat: number;
  vatRate: VatRate;
  vatTotal: number;
  total: number;
  receiptCustomerId: string;
  personId: null;
  isActivity: boolean;
  is_activity: boolean;
  is_product: boolean;
  subscription_id: null;
  subscription_customer_id: null;
  is_deposit: boolean;
  deposit_type: null;
  payment_id: null;
  deposit_appointment_id: null;
  is_giftcard: boolean;
  is_discount: boolean;
  discount_type_id: null;
  discount_type_name: null;
  activity: {
    uuid: string;
    name: string;
    treatmentCode: string | null;
  };
  person: Person;
}

type ReceiptCustomer =  {
  id: string;
  age: string | null;
  isMan: boolean;
  is_man: boolean;
  gender: 'M' | 'F' | 'X' | null;
  createdAt: string | null;
  receiptLines: ReceiptLine[];
  furfilled_loyalty_card_customer: string | null;
  loyalty_card_customer: string | null;
  subscriptions: [];
  image: string | null;
  customerId: number;
  birthday: string | null;
  name: string;
  firstName: string;
  lastName: string | null
  address: string;
  street: string;
  postal: string;
  city: string;
  phone: string | null;
  previous_receipt_id: string;
  previous_receipt_amount: number;
  loyaltyPoints: number | null;
  invoice_city: string | null;
  invoice_country: string | null;
  invoice_address: string | null;
  invoice_name: string | null;
  invoice_postal: string | null;
  invoice_vat_number: string | null;
  remarks: [];
  is_one_time_customer: boolean;
  is_send_newsletter: boolean;
  is_send_email: boolean;
  invoice_health_insurance_number?: string;
}

type MoneyFlow = {
  id: string;
  type: string;
  amount: number;
}

type RootObject = {
  data: {
    id: string;
    lockedAt: string;
    receiptCustomers: ReceiptCustomer[];
    activities: any[];
    moneyFlow: MoneyFlow[];
    ontab: null;
    invoices: any[];
    appointment_date: null
  };
}



export const createHICall = (data: IAPIHealthInsurance) => {
  const url = 'health-insurance/create'

  return ClientSDK.instance().post(url, data)
}

export const getReceiptCall = (receiptId: string) => {
  const url = `register/receipt/${receiptId}`

  return ClientSDK.instance().get<RootObject>(url)
}

export const getCustomerInvoiceData = (customerUuid: string) => {
  const url = `customers/${customerUuid}`
  return ClientSDK.instance().get<{data: IAPIInvoiceCustomer}>(url)
}
